import { createSlice } from '@reduxjs/toolkit';

import { loadProjects } from 'shared/thunks/admin/loadProjects';
import { TProject } from 'shared/types/project';
import { EStatus } from 'shared/types/status';

export type TProjectsState = {
  list: TProject[];
  total: number;
  status: EStatus;
};

const initialState: TProjectsState = {
  list: [],
  total: 0,
  status: EStatus.Loading,
};

export const projectsInitialState = initialState;

const projectsSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(loadProjects.pending, state => {
        state.status = EStatus.Loading;
      })
      .addCase(loadProjects.fulfilled, (state, action) => {
        state.list = action.payload.projects;
        state.total = action.payload.total;
        state.status = EStatus.Succeed;
      })
      .addCase(loadProjects.rejected, state => {
        state.status = EStatus.Failed;
      });
  },
  initialState,
  name: 'projects',
  reducers: {},
});

export const { reducer: projectsReducer } = projectsSlice;
